export const fromWidth = (minWidth: number) => `(min-width: ${minWidth}px)`;

export const toWidth = (maxWidth: number) => `(max-width: ${maxWidth}px)`;

export const betweenWidth = (minWidth: number, maxWidth: number) =>
  `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;

export const onlyWidth = (width: number, nextBreakPoint: number) =>
  `(min-width: ${width}px) and (max-width: ${nextBreakPoint - 0.02}px)`;

export const forTouchDevice = () => '(hover: none) and (pointer: coarse)';

export const forMouseDevice = () => '(hover: hover) and (pointer: fine)';

